import {
  BOX_SHADOW_FIELDS,
  FIELD_PLACEHOLDER_COLOR,
  INPUT_COLOR_BORDER,
} from "../utils/colors";
import { BORDER_RADIUS } from "../utils/constants";

/** Shared placeholder color overrides for MUI inputs (theme + local sx). */
export const inputPlaceholderSx = (color) => ({
  "&::placeholder": {
    color: `${color} !important`,
    WebkitTextFillColor: `${color} !important`,
    opacity: 1,
  },
  "&::-webkit-input-placeholder": {
    color: `${color} !important`,
    WebkitTextFillColor: `${color} !important`,
    opacity: 1,
  },
});

export const textFieldInputSx = {
  "& .MuiInputBase-root": {
    backgroundColor: "fields.background",
    borderRadius: BORDER_RADIUS,
    color: "#000 !important",
    border: `1px solid ${INPUT_COLOR_BORDER}`,
    boxShadow: BOX_SHADOW_FIELDS,
    "& input, & textarea": {
      color: "#000 !important",
      ...inputPlaceholderSx(FIELD_PLACEHOLDER_COLOR),
      "&.Mui-disabled": {
        WebkitTextFillColor: "#000 !important",
        color: "#000 !important",
        opacity: 1,
      },
    },
    "&.Mui-disabled": {
      WebkitTextFillColor: "#666666 !important",
      color: "#666666 !important",
      opacity: 0.9,
      "& input, & textarea": {
        WebkitTextFillColor: "#666666 !important",
        color: "#666666 !important",
        opacity: 0.9,
      },
    },
  },
  ".MuiFormHelperText-root": {
    mx: 0,
  },
};
